import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Grid, useTheme } from "@material-ui/core";
import { MenuItemCategory } from "../../../../models/types/category-types";
import { MenuCategoryDictionary, MenuSubcategoryDictionary } from "../../../../models/categories";
import { TopBarSubcategoryListItem } from "./tob-bar-subcategory-list-item";
import { TOP_BAR_ACCORDION_INSET } from "./top-bar-category-accordion";

interface ITopBarSubcategoryListStyleProps {
  color: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  listItemsContainer: {
    borderRadius: `0 0 0 ${theme.spacing(4)}px`,
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(TOP_BAR_ACCORDION_INSET),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(6),
    backgroundColor: ({ color }: ITopBarSubcategoryListStyleProps) => color,
  },
  listItem: {
    marginBottom: theme.spacing(1),
  },
}));

interface ITopBarSubcategoryListProps {
  category: MenuItemCategory;
  onActiveCategoryChanges: () => void;
}

export const TopBarSubcategoryList: FunctionComponent<ITopBarSubcategoryListProps> = (props) => {
  const theme = useTheme();
  const { category, onActiveCategoryChanges } = props;
  const categoryItem = MenuCategoryDictionary[category];
  const { color } = categoryItem;
  const subcategories = categoryItem.subcategories.map((subcategory) => ({
    name: subcategory,
    ...MenuSubcategoryDictionary[subcategory],
  }));

  const classes = useStyles({
    color: color ?? theme.palette.primary.main,
  });

  return (
    <Grid container>
      <Grid item container className={classes.listItemsContainer}>
        {subcategories.map((subcategory) => {
          return (
            <Grid item xs={12} className={classes.listItem} key={`subcategory-${subcategory.name}`}>
              <TopBarSubcategoryListItem
                category={category}
                subcategory={subcategory.name}
                onActiveCategoryChanges={onActiveCategoryChanges}
              />
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};
